import markdown from './markdown/index'
export default  markdown



// WEBPACK FOOTER //
// ./src/index.js